/**
 *
 * @module component/partials
 * @author shojib [mahmud.hossain@mlb.com]
 * @description module for adding handlebars partials
 *
 */

import postseasonPartial from '../../template/partials/postseason.html';
import controlsPartial from '../../template/partials/controls.html';
import gamesPartial from '../../template/partials/games.html';
import minisbHeaderPartial from '../../template/partials/minisb-header.html';
import minisbLogosPartial from '../../template/partials/minisb-logos.html';
import spinnerPartial from '../../template/partials/spinner.html';

/**
 *
 * @name partials
 * @description handlebars partials to be registered
 *
 */
const partials = {
    postseasonPartial,
    controlsPartial,
    gamesPartial,
    minisbHeaderPartial,
    minisbLogosPartial,
    spinnerPartial
};

export default partials;
